import React , {useState} from 'react';

import PageTitle from '../components/pagetitle/PageTitle';
import Faqs from '../components/faqs/Faqs';
import Footer from '../components/footer/Footer';
import dataFaqs from '../assets/fake-data/data-faq';

import img from '../assets/images/layouts/map.png'
import img1 from '../assets/images/layouts/par-01.png'
import img2 from '../assets/images/layouts/par-02.png'
import img3 from '../assets/images/layouts/par-03.png'
import { Link } from 'react-router-dom';

function ParticipantAssets(props) {

    const [data] = useState([
        {
            id: 1,
            img: img1,
        },
        {
            id: 2,
            img: img2,
        },
        {
            id: 3,
            img: img3,
        }
    ])
    return (
        <div className='wrapper'>

            <PageTitle title='The Movement' />

            <section className="participants">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="block-text center">
                                <h3 className="heading">Our Community</h3>
                            </div>
                        </div>

                        {
                            data.map(idx => (
                                <div key={idx.id} className="col-md-4">
                                    <div className="blog-box">
                                        <div className="image">
                                            <Link to="#"><img src={idx.img} alt="Cyfonii" /></Link>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }

                        <div className="col-12">
                            <div className="par-bot center">
                                <p className="mb-17">At NXTLVL, our community is the heartbeat of every experience — from the dance floor to behind the scenes.</p>
                                <p className="mb-28">We collaborate with top promoters, creatives, and tastemakers to build unforgettable moments. If you're ready to elevate, you're in the right place.</p>
                                <Link to="#" className="action-btn"><span>Join us</span></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="assets">
                <div className="shape"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="block-text center">
                                <h3 className="heading">The Experience Tree</h3>
                                <p>NXTLVL is more than events — it’s a dynamic network of nightlife, talent, media, and partnerships. This visual map shows how everything connects to create the ultimate experience.</p>
                            </div>

                            <div className="assets__main center">
                                <h5>NXTLVL Experience Map</h5>
                                <img src={img} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Faqs data={dataFaqs} />
            <Footer />
        </div>
    );
}

export default ParticipantAssets;